export declare interface Product {
  optimizedUniqueTitle: string;
  image: string;
  isbn: string;
  isbn13: string;
  contributors: Array<string>;
  publicationDate: string;
  edition: number;
  publicationStatus: string;
  SEARCH_EXCLUDE: boolean;
  CONTRIBUTOR_INFO: Array<string>;
  instructorOnly: boolean;
  LIST_PRICE: number;
  NET_PRICE: number;
  INSTRUCTOR_BENEFITS: string;
  AFFORDABILITY_INFO: string;
  IS_ALEKS: boolean;
  SCDF_PRODUCT_ISBN13: Array<string>;
  PACKAGE_PRODUCT_ISBN13: Array<string>;
  RELATED_PRODUCT_ISBN13: Array<string>;
  NOT_AVAILABLE_INDIVIDUALLY: boolean;
  INSTRUCTOR_COMP: boolean;
  PDP_TOC: string;
  IS_MASTER: boolean;
  IS_DIGITAL_ASSET: boolean;
  PDP_DESCRIPTION: string;
  contributor_details: {
    sequence: number;
    contributorFirstName: string;
    contributorLastName: string;
    contributorbBio: string;
  };
  scdfs: Array<Product>;
  packages: Array<Product>;
  related: Array<Product>;
  id: string;
  title: string;
  seoTitle: string;
  description: string;
  copyrightYear: string;
  gradeLevels: string;
  gradeLevelStart: string;
  gardeLevelEnd: string;
}

export declare interface ProductResponse {
  data?: Product;
  isLoading: boolean;
  isLoaded: boolean;
  isSuccess: boolean;
  isFailure: boolean;
  message: string;
}

export declare interface ProductState {
  products: {
    [name: string]: ProductResponse;
  };
}

export enum ItemType {
  aleks = 'aleks',
  aleksll = 'aleks-looseleaf',
  apr = 'apr',
  connect = 'connect',
  ltia = 'STANDALONE_EBOOKS',
  mhGo = 'goldy',
  nutricalc = 'nutricalc',
  simnet = 'simnet',
  virtualLabs = 'virtual-labs',
}

export enum ItemTypeLabel {
  connect = "connect",
  apr = "APR",
  nutricalc = "Nutricalc",
  STANDALONE_EBOOKS = "Standalone eBooks",
  goldy = "Goldy",
  aleks = "ALEKS",
  simnet = "SIMnet",
  "aleks-looseleaf" = "ALEKS Looseleaf"
}

export enum CtaTypeLabel {
  NO_CTA = "noCta",
  VIEW_ITEM = "viewItemButton",
  ADD_TO_CART = "addToCart"
}